import React from "react";
import styled from "@emotion/styled";
import { SCORE_BANDS } from "../../../utils/Service/colors";

const ScoreLegend = () => (
  <LegendWrap>
    <LegendLabel>Score Range</LegendLabel>
    <SwatchRow>
      {SCORE_BANDS.map((band) => (
        <Swatch key={band.label} bg={band.bg}>
          {band.label}
        </Swatch>
      ))}
    </SwatchRow>
  </LegendWrap>
);

const LegendWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
`;

const LegendLabel = styled.span`
  font-size: 0.8rem;
  font-weight: 700;
  color: #16325c;
  white-space: nowrap;
`;

const SwatchRow = styled.div`
  display: flex;
  gap: 4px;
`;

const Swatch = styled.span`
  background: ${(props) => props.bg};
  color: #353e4c;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
`;

export default ScoreLegend;
